module.exports = require("core-js/modules/es.symbol.description.js");